module.exports = __webpack_public_path__ + "img/6.138d19f6.jpg";